import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createEvent } from '../services/api';
import { FaImages, FaTimes } from 'react-icons/fa';

const CreateEvent = () => {
  const [formData, setFormData] = useState({
    name: '',
    category: 'wedding',
    description: '',
    event_date: '',
    location: '',
    visibility: 'public',
    access_code: ''
  });
  const [coverPhotoFile, setCoverPhotoFile] = useState(null);
  const [coverPhotoPreview, setCoverPhotoPreview] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const categories = [
    'wedding',
    'birthday',
    'corporate',
    'conference',
    'party',
    'graduation',
    'family',
    'sports',
    'concert',
    'other'
  ];

  const categoryLabels = {
    wedding: 'Mariage',
    birthday: 'Anniversaire',
    corporate: 'Entreprise',
    conference: 'Conférence',
    party: 'Fête',
    graduation: 'Remise de diplôme',
    family: 'Famille',
    sports: 'Sports',
    concert: 'Concert',
    other: 'Autre'
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleCoverPhotoChange = (e) => {
    const file = e.target.files?.[0] || null;
    setCoverPhotoFile(file);
    setCoverPhotoPreview(file ? URL.createObjectURL(file) : '');
  };

  const removeCoverPhoto = () => {
    setCoverPhotoFile(null);
    setCoverPhotoPreview('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      let payload = formData;

      if (coverPhotoFile) {
        payload = new FormData();
        Object.entries(formData).forEach(([key, value]) => {
          payload.append(key, value ?? '');
        });
        payload.append('cover_photo', coverPhotoFile);
      }

      console.log('Submitting event creation with data:', formData);  
      const response = await createEvent(payload);

      console.log('Event created successfully:', response);  
      navigate(`/event/${response.event.id}/photos`);
    } catch (err) {
      setError(err.response?.data?.message || "Impossible de créer l'événement");
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="auth-container" style={{ maxWidth: '600px' }}>
        <h2 style={{ textAlign: 'center', color: 'var(--primary-orange)' }}>
          Créer un nouvel événement
        </h2>
        <p style={{ textAlign: 'center', color: 'var(--gray)', marginBottom: '2rem' }}>
          Configurez un nouvel événement photo pour organiser et importer vos photos
        </p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nom de l'événement *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="ex. Mariage Durand 2024"
            />
          </div>

          <div className="form-group">
            <label>Catégorie de l'événement *</label>
            <select
              name="category"
              value={formData.category}
              onChange={handleChange}
              required
            >
              {categories.map((cat) => (
                <option key={cat} value={cat}>
                  {categoryLabels[cat] || cat}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Visibilité *</label>
            <select
              name="visibility"
              value={formData.visibility}
              onChange={handleChange}
              required
            >
              <option value="public">Public - Tout le monde peut voir</option>
              <option value="unlisted">Non listé - Uniquement avec le lien</option>
              <option value="private">Privé - Code d'accès requis</option>
            </select>
          </div>

          {formData.visibility === 'private' && (
            <div className="form-group">
              <label>Code d'accès</label>
              <input
                type="text"
                name="access_code"
                value={formData.access_code}
                onChange={handleChange}
                placeholder="Saisissez le code d'accès pour cet événement"
              />
            </div>
          )}

          <div className="form-group">
            <label>Lieu</label>
            <input
              type="text"
              name="location"
              value={formData.location}
              onChange={handleChange}
              placeholder="e.g., Paris, France"
            />
          </div>

          <div className="form-group">
            <label>Date de l'événement</label>
            <input
              type="date"
              name="event_date"
              value={formData.event_date}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Description</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows="4"
              placeholder="Ajoutez des détails supplémentaires sur l'événement..."
            />
          </div>

          <div className="form-group">
            <label>Photo de couverture</label>
            <div style={{
              border: '2px dashed var(--light-gray)',
              borderRadius: '10px',
              padding: '1rem',
              background: 'var(--off-white)',
            }}>
              {coverPhotoPreview ? (
                <div style={{ position: 'relative' }}>
                  <img
                    src={coverPhotoPreview}
                    alt="Aperçu de la couverture"
                    style={{
                      width: '100%',
                      height: '180px',
                      objectFit: 'cover',
                      borderRadius: '8px',
                      display: 'block',
                    }}
                  />
                  <button
                    type="button"
                    onClick={removeCoverPhoto}
                    aria-label="Retirer la photo de couverture"
                    style={{
                      position: 'absolute',
                      top: '0.5rem',
                      right: '0.5rem',
                      width: '34px',
                      height: '34px',
                      borderRadius: '50%',
                      border: 'none',
                      background: 'rgba(0,0,0,0.65)',
                      color: 'white',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <FaTimes />
                  </button>
                </div>
              ) : (
                <label
                  htmlFor="coverPhotoInput"
                  style={{
                    minHeight: '150px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '0.6rem',
                    color: 'var(--gray)',
                    cursor: 'pointer',
                    textAlign: 'center',
                  }}
                >
                  <FaImages style={{ fontSize: '2rem', color: 'var(--primary-orange)' }} />
                  <strong style={{ color: 'var(--dark-gray)' }}>Choisir une photo de couverture</strong>
                  <span style={{ fontSize: '0.9rem' }}>JPG, PNG, or WEBP</span>
                </label>
              )}
              <input
                id="coverPhotoInput"
                type="file"
                accept="image/*"
                onChange={handleCoverPhotoChange}
                style={{ display: 'none' }}
              />
              {coverPhotoPreview && (
                <label
                  htmlFor="coverPhotoInput"
                  style={{
                    display: 'inline-block',
                    marginTop: '0.75rem',
                    color: 'var(--primary-orange)',
                    fontWeight: '600',
                    cursor: 'pointer',
                  }}
                >
                  Changer la photo de couverture
                </label>
              )}
            </div>
          </div>

          <button type="submit" className="btn-submit" disabled={loading}>
            {loading ? "Création de l'événement..." : "Créer l'événement"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default CreateEvent;
